export interface IEmail {
  email: string;
}
export interface IPassword {
  newPassword: string;
}
export interface IChangePassword extends IPassword {
  userId?: string;
}
